import { createSelector } from 'reselect';
import { serviceProviderId, serviceProviderPermissions } from './serviceProviderSelectors.js';
import { permissions } from './appSelectors.js';

const stableObject = {};
const stableArray = [];

const serviceProviders = (state) => (state.app || stableObject).serviceProviders || stableArray;

export const user = (state) => state.user;
export const userId = (state) => state.user.id;
export const tresioUser = (state) => state.user.tresioUser;
export const loggedIn = (state) => state.user.loggedIn;
export const defaultTrackedPhoneId = (state) => state.user.defaultTrackedPhoneId;
export const userServiceProviderIds = (state) => (state.user || stableObject).serviceProviderIds || stableArray;
export const userServiceProviders = createSelector(serviceProviders, userServiceProviderIds, (serviceProviders, ids) => {
  return serviceProviders.filter((n) => ids.includes(n.id));
});
export const userServiceProvider = createSelector(serviceProviderId, userServiceProviders, (serviceProviderId, userServiceProviders) => userServiceProviders.find((n) => n.id === serviceProviderId));
export const hasPermission = (permission) =>
  createSelector(tresioUser, serviceProviderPermissions, permissions, (tresioUser, userPermissions, permissions) => {
    return tresioUser || userPermissions.includes(permission);
  });

export const allPermissions = () =>
  createSelector(serviceProviderPermissions, permissions, (userPermissions, permissions) => {
    return userPermissions
      .map((n) => permissions.find((o) => o.id === n))
      .filter((n) => !!n)
      .map((n) => n.name);
  });
